module.exports = __webpack_public_path__ + "static/MerriweatherLightItalic-f0aa1f1dacd8e9b9ffca261598786ff1.woff2";